<template>
  <el-dialog :visible.sync="visible"
             :title="title"
             center
             width="800px">
    <el-form :model="model"
             size="small"
             :inline="true">
      <el-form-item label="商品分类：">
        <el-cascader v-model="productCategory"
                     placeholder="请选择分类"
                     clearable
                     :props="props"
                     @change="handleCategoryChange"></el-cascader>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input v-model="model.keyword"
                  style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="getList">查询</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格栏 -->
    <el-table :data="goodsList"
              size="small"
              height="300"
              border
              @selection-change="handleSelectionChange">
      <el-table-column prop="id"
                       type="selection"
                       width="50"
                       align="center"></el-table-column>
      <el-table-column prop="name"
                       label="商品名称"
                       align="center">
      </el-table-column>
      <el-table-column label="售价"
                       align="center">
        <template slot-scope="scope">
          <div>￥<span class="color-danger">{{scope.row.price}}</span>{{scope.row.unit}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-row>
      <div class="pagination-container">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       layout="total, sizes, prev, pager, next, jumper"
                       :page-size="model.pageSize"
                       :page-sizes="[10, 20, 30, 50, 100]"
                       :current-page.sync="model.pageNum"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!-- 底部栏 -->
    <div slot="footer">
      <el-button type="primary"
                 size="medium"
                 :loading="loading"
                 @click="submit">确认</el-button>
      <el-button size="medium"
                 @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getProductAllList } from '@/api/product'
import { shopClassifyList } from '@/api/shopClassify'

const defaultModel = {
  verifyStatus: 1,
  publishStatus: 1,
  keyword: null,
  pageNum: 1,
  pageSize: 20,
  productSn: null,
  productCategoryId: null,
  productCategoryIdI: null,
  productCategoryIdIii: null,
  brandId: null,
  labelId: null,
  mchtId: null,
  promotionType: 0,
  sortType: 1
}
// 选择商品
export default {
  name: 'selectGoodsDialog',
  data() {
    const that = this
    return {
      visible: false,
      title: null,
      loading: false,
      model: Object.assign({}, defaultModel),
      productCategory: [],
      goodsList: [],
      multipleSelection: [],
      total: 0,
      props: {
        expandTrigger: 'hover',
        lazy: true,
        lazyLoad(row, resolve) {
          if (row.level == 0) {
            row.value = 0
          }
          shopClassifyList({
            parentId: row.value,
            mchtId: that.$store.getters.mchtId,
            status: 2
          }).then(res => {
            let list = res.data
            list.map(item => {
              item.value = item.productCategoryId
              item.label = item.productCategoryName
              item.leaf = item.level >= 3
            })
            resolve(list)
          })
        }
      }
    }
  },
  methods: {
    show() {
      this.model.mchtId = this.$store.getters.mchtId
      this.visible = true
      this.getList()
      this.title = '选择商品'
    },
    // 每页页数变化
    handleSizeChange(val) {
      this.multipleSelection.pageNum = 1
      this.model.pageSize = val
      this.getList()
    },
    //当前页变化
    handleCurrentChange(val) {
      this.model.pageNum = val
      this.getList()
    },
    getList() {
      this.listLoading = true
      getProductAllList(this.model).then(response => {
        this.listLoading = false
        this.goodsList = response.data.list
        this.total = response.data.total
      }).catch(err => {
        this.listLoading = false
      })
    },
    // 监听级联面板value
    handleCategoryChange() {
      this.model.productCategoryIdI = this.productCategory[0]
      this.model.productCategoryId = this.productCategory[1]
      this.model.productCategoryIdIii = this.productCategory[2]
    },
    // 勾选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    submit() {
      // 确定
      this.$emit('ok', this.multipleSelection)
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
<style scoped>
.input-width {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/views/sms/components/SelectGoodsDialog.vue